// extracted by mini-css-extract-plugin
export var articleList = "article-preview-module--article-list--2zSz0";
export var header = "article-preview-module--header--2qej6";
export var title = "article-preview-module--title--1Uq8k";
export var link = "article-preview-module--link--3fhjt";